// extracted by mini-css-extract-plugin
module.exports = {"root":"AuthenticatedLayout_root__3p2ih","content":"AuthenticatedLayout_content__1_gax"};